import { injectable } from 'tsyringe';

// -------------------------------------------------------------
@injectable()
export class OWCustomURLWrapper {
  // -------------------------------------------------------------
  public openNotificationsSettings() {
    window.location.href = 'overwolf://settings/notifications';
  }
}
